import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useContext, useState } from 'react';
import UserContext from '../../../../../../shared-components/contexts/UserContext';
import {
  GetCoreUserFormattedName,
  ICoreUser,
} from '../../../../../../shared-interfaces/User/ICoreUser';
import CookieService from '../../../../../../shared-services/CookieService';
import ConnectionsService from '../Services/ConnectionsService';

export interface RemoveConnectionDialogProps {
  open: boolean;
  onClose: () => void;
  onRemove: (student: ICoreUser, advisor: ICoreUser) => void;
  student: ICoreUser;
  advisor: ICoreUser;
}

const RemoveConnectionDialog = (props: RemoveConnectionDialogProps) => {
  const user = useContext(UserContext);
  const { enqueueSnackbar } = useSnackbar();

  const [isDeleting, setIsDeleting] = useState(false);

  const handleSubmit = () => {
    setIsDeleting(true);
    ConnectionsService.deleteAdvisorConnection(user.id, props.student.id, [
      props.advisor.id,
    ])
      .then(() => {
        props.onRemove(props.student, props.advisor);
      })
      .then(() => {
        enqueueSnackbar('Connection Removed', { variant: 'success' });
      })
      .catch(() => {
        enqueueSnackbar('Something went wrong', { variant: 'error' });
      })
      .finally(() => {
        setIsDeleting(false);

        CookieService.Create(
          `BeaconConnectionChanged_${props.student.id}`,
          'true',
          undefined,
          undefined,
          'lax',
          5,
        );

        props.onClose();
      });
  };

  return (
    <Dialog
      aria-labelledby="remove-connection-title"
      open={props.open}
      onClose={props.onClose}
    >
      <DialogTitle id="remove-connection-title">Remove Connection</DialogTitle>
      <form>
        <DialogContent>
          <DialogContentText component="div">
            Are you sure you want to remove this connection?
            <p style={{ textAlign: 'center', fontWeight: 600 }}>
              {GetCoreUserFormattedName(props.student, false)}
            </p>
            <p style={{ textAlign: 'center' }}>from</p>
            <p style={{ textAlign: 'center', fontWeight: 600 }}>
              {GetCoreUserFormattedName(props.advisor, false)}
            </p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={props.onClose}
            color="primary"
            variant="text"
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            color="secondary"
            variant="contained"
            disabled={isDeleting}
          >
            Remove
          </Button>
        </DialogActions>
        {isDeleting && <LinearProgress />}
      </form>
    </Dialog>
  );
};

export default RemoveConnectionDialog;
